import { Flex, SimpleMemoryRouterOutlet } from '@workwhile/ui'
import React from 'react'
import { Header } from './Header'
import { Stepper } from './Stepper/Stepper'

export const BulkCreateShiftsMain = () => {
  return (
    <Flex flexDirection="column" gap={3} height="100%">
      <Header />
      <Stepper />
      <SimpleMemoryRouterOutlet />
    </Flex>
  )
}
